// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"menu-link-module--linkItem--3Y72j","link":"menu-link-module--link--j5BR9","play":"menu-link-module--play--1RgrR","disabled":"menu-link-module--disabled--12ZCC"};